import { RootState } from '../store';
export const selectMenu = (state: RootState) => state.sidebarMenu;
